import { useContext, useEffect } from 'react'
import { Link } from 'react-router-dom'
import { observer } from 'mobx-react-lite'
import styled from 'styled-components'

import { StoresContext } from '../../../provider/StoreProvider'

import { Wrap } from '../../../components/container/Wrap'
import { Content } from '../../../components/container/Content'
import { Header } from '../../../components/header'
import { PagingContent } from '../../../components/pagingList'

export const EventList = observer(() => {
  const { artfairStore, commonStore } = useContext(StoresContext)
  const pagingStore = artfairStore.eventPagingStore

  useEffect(() => {
    commonStore.setShowTab(false)

    pagingStore.load(undefined, true)
  }, [])

  useEffect(() => {
    commonStore.setShowTab(false)
  }, [])

  return (
    <Wrap>
      <Header type="SUB" title="이벤트" />
      <Content>
        <PagingContent pagingStore={pagingStore} emptyText="조회 가능한 이벤트가 없습니다.">
          <List>
            {pagingStore.list.map(({ id, imageUri, title }) => (
              <Link key={id} to={`/event/${id}`}>
                <ImageThumbnail>
                  <img
                    src={imageUri}
                    alt={title}
                    onError={({ currentTarget }) => {
                      currentTarget.onerror = null
                      currentTarget.src = '/img/thumbnail.svg'
                    }}
                  />
                </ImageThumbnail>
              </Link>
            ))}
          </List>
        </PagingContent>
      </Content>
    </Wrap>
  )
})

const List = styled.ul`
  display: flex;
  flex-direction: column;
  gap: 16px;
  padding: 24px 16px;
`

const ImageThumbnail = styled.li`
  overflow: hidden;
  width: 100%;
  aspect-ratio: 1 / 0.22;
  border-radius: 8px;
  > img {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
`
